export default "__VITE_ASSET__C3N7O0g8__"